import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import {
  getMembership,
  saveMembershipByAccount,
  updateMembership,
} from './MembershipService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Checkbox, FormControlLabel } from '@mui/material';

import SubscriptionList from '../Subscriptions/SubscriptionList';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const MembershipDetail = (): JSX.Element => {
  //const { sectionid, itemid } = useParams();
  //   const { sectionid = '' } = useParams<{ sectionid: string }>();
  //   const { itemid = '' } = useParams<{ itemid: string }>();

  const [membershipName, setMembershipName] = useState('');
  const [status, setStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [enabled, setEnabled] = useState(false); // Initialize as false
  const navigate = useNavigate();
  const { accountid } = useParams();
  const { membershipid } = useParams();

  function clearMembershipDetailsForm() {
    setMembershipName('');
    setStatus('');
    setStartDate('');
    setEndDate('');
    setEnabled(false);
  }

  const cancelSaveOrUpdateMembership = () => {
    clearMembershipDetailsForm();
    // navigate(`/system/account/{accountid}`)
    navigate(`/system/account/${accountid}`);
  };

  function saveOrUpdateMembership(e) {
    e.preventDefault();

    const membership = {
      membershipName,
      status,
      startDate,
      endDate,
      enabled,
    };

    if (membershipid) {
      updateMembership(membershipid, membership)
        .then(() => {
          navigate(
            `/system/dashboard/account/${accountid}/membership/${membershipid}`,
          );
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveMembershipByAccount(accountid, membership)
        .then(() => {
          navigate(`/system/dashboard/account/${accountid}`);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (membershipid) {
      console.log('membershipid exists: ', membershipid);
      getMembership(accountid, membershipid)
        .then((response) => {
          console.log(response.data);
          setMembershipName(response.data.membershipName);
          setStartDate(response.data.startDate);
          setEndDate(response.data.endDate);
          setStatus(response.data.status);
          setEnabled(response.data.enabled);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [membershipid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/accounts'}
            >
              Accounts
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/memberships'}
            >
              Memberships
            </Link>
            <Typography color="text.primary">Membership Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Memberships Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Membership Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'membershipName'}
                  fullWidth
                  value={membershipName} // Use the 'sequence' state variable as the value
                  onChange={(event) => setMembershipName(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Start Date
                </Typography>
                <TextField
                  variant="outlined"
                  name={'startDate'}
                  fullWidth
                  value={startDate} // Use the 'name' state variable as the value
                  onChange={(event) => setStartDate(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  End Date
                </Typography>
                <TextField
                  variant="outlined"
                  name={'endDate'}
                  fullWidth
                  value={endDate} // Use the 'name' state variable as the value
                  onChange={(event) => setEndDate(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Status
                </Typography>
                <TextField
                  variant="outlined"
                  name={'status'}
                  fullWidth
                  value={status} // Use the 'name' state variable as the value
                  onChange={(event) => setStatus(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Enabled?
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={enabled} // Use the 'enabled' state variable as the checked value
                      onChange={(event) => setEnabled(event.target.checked)} // Update the 'enabled' state variable on change
                      name="enabled" // Name for the checkbox (optional)
                    />
                  }
                  label="Enabled"
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdateMembership}>Cancel</Button>
                  <Button onClick={saveOrUpdateMembership}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Box>
          <SubscriptionList />
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default MembershipDetail;
